import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW0300Component } from "src/app/commons/kymw03/kymw0300/kymw0300.component";
import { KYMW0300InputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-input.model";
import { KYMW0300OutputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model";
import { GetGoodsListService } from "./api-services/get-goods-list.service";
import { KYMW6902Model } from "./kymw6902.model";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { KYMW0300Model } from "src/app/commons/kymw03/kymw0300/kymw0300.model";

@Component({
  selector: 'app-kymw6902',
  templateUrl: 'kymw6902.component.html',
  styleUrls: ['kymw6902.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW6902Component extends PlessViewHelperSub implements OnInit {
  model = new KYMW6902Model();
  kymw0300InputVO = new KYMW0300InputModel();
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  constructor(
    protected kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getGoodsListService: GetGoodsListService
  ) {
    super(kymw00Model);
  }

  get output() {
    return this.model.goodsList[this.model.selectedRowIndex];
  }

  ngOnInit(): void {
    this.componentName = 'KYMW6902';
  }

  eventSearch_CLICKHandler() {
    this.openModal();
  }

  private openModal() {
    const componentRef = this.dialogService.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    // 企画関連条件を表示しない（企画検索フラグ:0）
    this.kymw0300InputVO.catalogSearchFlg = 0;

    instance.setInterfaceParam(this.kymw0300InputVO);
    instance.setKYMW0300Parameter = (kymw0300OutputVO: KYMW0300OutputModel) => {
      this.model.setSearchParams(kymw0300OutputVO);
      this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(kymw0300OutputVO);
      this.getGoodsListService.execute(this.model, this.model.pagenation.currentPageNum());
      instance.closeFunction();
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  eventBack_CLICKHandler() {
    this.getGoodsListService.execute(this.model, this.model.pagenation.prevPageNum(), () => {
      this.model.resetSelectedRowIndex();
    });
  }

  eventNext_CLICKHandler() {
    this.getGoodsListService.execute(this.model, this.model.pagenation.nextPageNum(), () => {
      this.model.resetSelectedRowIndex();
    });
  }


  eventCopy_CLICKHandler() {
    this.closeFunction();
  }

  onClickWindowClose() {
    if (this.model.goodsList.length) {
      this.dialogService.openAlertGetMessage('Q0175', [], (closeDetail: PlessAlert) => {
        if (closeDetail === PlessAlert.Yes) {
          this.closeFunction(true);
        }
      });
    } else {
      this.closeFunction(true);
    }
  }

}